import React, { useState, useEffect, useRef } from 'react';
import { Button, Dropdown, Grid } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './Flipper.css';
import { ReactSVG } from 'react-svg';
import * as icons from '../../assets/images/toolbarIcons/_toolbarIcons';

const Flipper = props => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let target, imageTarget;
  const [isMobile, setIsMobile] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [flipperDD, setFlipperDD] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 650) {
      setIsMobile(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const useOutsideAlerter = ref => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (showItems) {
          setShowItems(false);
        }
      }
    };
    useEffect(() => {
      setFlipperDD(document.getElementById('flipperDD'));
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  };

  useEffect(() => {
    if (isMobile) {
      if (flipperDD) {
        // document.getElementById('workplace').appendChild(flipperDD);
      }
      if (showItems) {
        document.getElementById('flipperDD').style.display = 'block';
      } else {
        document.getElementById('flipperDD').style.display = 'none';
      }
    }
  }, [showItems]);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  if (props.targetId < 0 || props.targetId === '-0') {
    const backgroundElement = document.getElementById(`B_${props.pageId}`);
    target = backgroundElement.querySelector('.flipper');
  } else {
    const mainTarget = document.getElementById(`_${props.targetId}_`);
    if (props.targetType == 'Frame') {
      imageTarget = mainTarget && mainTarget.querySelectorAll('.flipper')[1];
    }
    target = mainTarget && mainTarget.querySelector('.flipper');
  }
  const getScale = el => {
    let m = el.style.transform;
    let elScale = m.substring(m.indexOf('(') + 1, m.indexOf(')')).split(',');

    let scaleObject = {};
    if (elScale[0] === '') {
      scaleObject = { x: 1, y: 1 };
    } else {
      if (!elScale[1]) {
        scaleObject = { x: parseInt(elScale[0]), y: parseInt(elScale[0]) };
      } else {
        scaleObject = { x: parseInt(elScale[0]), y: parseInt(elScale[1]) };
      }
    }

    return scaleObject;
  };

  const saveChanes = () => {
    let data;
    data = {
      flip: { transform: target.style.transform },
    };

    if (props.targetType === 'Frame') {
      let imgData = { medias: { style: { flip: { transform: imageTarget.style.transform } } } };
      dispatch(designActions.changeEntityStyle(props.pageId, props.targetId, data));
      dispatch(designActions.changeFrameData(props.pageId, props.targetId, imgData));
    } else {
      dispatch(designActions.changeEntityStyle(props.pageId, props.targetId, data));
    }
  };

  const flipH = () => {
    if (!target) return;
    let scale = getScale(target);

    scale.x = scale.x * -1;
    target.style.transform = 'scale(' + scale.x + ',' + scale.y + ')';

    saveChanes();
  };

  const flipV = () => {
    if (!target) return;
    let scale = getScale(target);
    scale.y = scale.y * -1;
    target.style.transform = 'scale(' + scale.x + ',' + scale.y + ')';

    saveChanes();
  };

  const frameImgFlipH = () => {
    if (!imageTarget) return;
    let scale = getScale(imageTarget);

    scale.x = scale.x * -1;
    imageTarget.style.transform = 'scale(' + scale.x + ',' + scale.y + ')';

    saveChanes();
  };

  const frameImgFlipV = () => {
    if (!imageTarget) return;
    let scale = getScale(imageTarget);
    scale.y = scale.y * -1;
    imageTarget.style.transform = 'scale(' + scale.x + ',' + scale.y + ')';

    saveChanes();
  };

  const toggleCollapse = () => {
    setShowItems(!showItems);
  };

  const toolItems = (
    <div id="flipperDD" className="toolsHolderContainer flipper" ref={wrapperRef}>
      <Grid columns="two">
        <Grid.Row>
          <Grid.Column>
            <Button title="Flip Horizontal" onMouseDown={flipH}>
              <ReactSVG src={icons.flipHorizontal} />
              <span>{t('flipHorizontal')}</span>
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button title="Flip Vertical" onMouseDown={flipV}>
              <ReactSVG src={icons.flipVertical} />
              <span>{t('flipVertical')}</span>
            </Button>
          </Grid.Column>
        </Grid.Row>
        {props.targetType == 'Frame' && (
          <Grid.Row>
            <Grid.Column>
              <Button title="Flip Horizontal Image" onMouseDown={frameImgFlipH}>
                <ReactSVG src={icons.flipHorizontal} />
                <span>{t('flipHorizontalImage')}</span>
              </Button>
            </Grid.Column>
            <Grid.Column>
              <Button title="Flip Vertical Image" onMouseDown={frameImgFlipV}>
                <ReactSVG src={icons.flipVertical} />
                <span>{t('flipVerticalImage')}</span>
              </Button>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </div>
  );
  return (
    <>
      {isMobile ? (
        <>
          <div className="toolsHolder flipTool mobile">
            <Button title="Flip" onMouseDown={toggleCollapse}>
              <span>{t('flip')}</span>
            </Button>
          </div>
          {toolItems}
        </>
      ) : (
        <Dropdown className="text toolsHolder button" title="Flip" text={t('flip')}>
          <Dropdown.Menu>{toolItems}</Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
};

Flipper.propTypes = {
  pageId: PropTypes.number,
  targetId: PropTypes.number,
  targetType: PropTypes.string,
};

export default Flipper;
